import React from "react";
import { WEB_ROUTES } from "./constants.js";
import DietaryManagementScreen from "./Pages/DietaryManagement/DietaryManagementScreen.js";
import MentalHealthManagementScreen from "./Pages/MentalHealthManagement/MentalHealthManagementScreen.js";
import ActivityManagementScreen from "./Pages/ActivityManagement/ActivityManagementScreen.js";

const Account = React.lazy(() => import("./Pages/Account/index.js"));
const Dashboard = React.lazy(() => import("./Pages/Dashboard/index.js"));

const ProductManagementScreen = React.lazy(() =>
  import("./Pages/ProductManagement/ProductManagementScreen.js")
);

const FAQManagementScreen = React.lazy(() =>
  import("./Pages/FaqManagement/FaqManagementScreen.js")
);
const TournamentQuestionManagementScreen = React.lazy(() =>
  import(
    "./Pages/TournamentQuestionManagement/TournamentQuestionManagementScreen.js"
  )
);
const TournamentManagementScreen = React.lazy(() =>
  import("./Pages/TournamentManagement/TournamentManagementScreen.js")
);
const QuestionManagementScreen = React.lazy(() =>
  import("./Pages/QuestionManagement/QuestionManagementScreen.js")
);
const BadgeManagementScreen = React.lazy(() =>
  import("./Pages/BadgeManagement/BadgeManagementScreen.js")
);
const GenreManagementScreen = React.lazy(() =>
  import("./Pages/GenreManagement/GenreManagementScreen.js")
);
const CategoryManagementScreen = React.lazy(() =>
  import("./Pages/CategoryManagement/CategoryManagementScreen.js")
);
const PageManagementScreen = React.lazy(() =>
  import("./Pages/PageManagement/PageManagementScreen.js")
);
const SendNotificationScreen = React.lazy(() =>
  import("./Pages/SendNotification/SendNotificationScreen.js")
);
const Setting = React.lazy(() => import("./Pages/Setting/index.js"));
const UserDetails = React.lazy(() =>
  import("./Pages/UserManagement/UserDetails.js")
);
const UserManagementScreen = React.lazy(() =>
  import("./Pages/UserManagement/UserManagementScreen.js")
);
const TasksManagementScreen = React.lazy(() =>
  import("./Pages/TasksManagement/TasksManagementScreen.js")
);
const TaskDetails = React.lazy(() =>
  import("./Pages/TasksManagement/TaskDetails.js")
);
const TransactionsManagementScreen = React.lazy(() =>
  import("./Pages/TransactionsManagement/TransactionsManagementScreen.js")
);
const TransactionDetails = React.lazy(() =>
  import("./Pages/TransactionsManagement/TransactionDetails.js")
);
const ReportedTasksManagementScreen = React.lazy(() =>
  import("./Pages/ReportedTasksManagement/ReportedTasksManagementScreen.js")
);
const ReportedTaskDetails = React.lazy(() =>
  import("./Pages/ReportedTasksManagement/ReportedTaskDetails.js")
);

export const routeConfig = [
  {
    path: WEB_ROUTES.ACCOUNT,
    component: Account,
    isPublic: true,
    exact: true,
  },
  {
    path: WEB_ROUTES.DASHBOARD,
    component: Dashboard,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.USER_MANAGEMENT,
    component: UserManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.USER_DETAILS,
    component: UserDetails,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.CATEGORY_MANAGEMENT,
    component: CategoryManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.DIETARY_RESTRICTIONS,
    component: DietaryManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.MENTAL_HEALTH_MANAGEMENT,
    component: MentalHealthManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.ACTIVITY_MANAGEMENT,
    component: ActivityManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.QUESTION_MANAGEMENT,
    component: QuestionManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.TOURNAMENT_MANAGEMENT,
    component: TournamentManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.PRODUCT_MANAGEMENT,
    component: ProductManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.TOURNAMENT_QUESTION_MANAGEMENT,
    component: TournamentQuestionManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.PAGE_MANAGEMENT,
    component: PageManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.FAQ_MANAGEMENT,
    component: FAQManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.SEND_NOTIFICATION,
    component: SendNotificationScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.SETTING,
    component: Setting,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.TASKS_MANAGEMENT,
    component: TasksManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.TASKS_DETAILS,
    component: TaskDetails,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.TRANSACTIONS_MANAGEMENT,
    component: TransactionsManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.TRANSACTION_DETAILS,
    component: TransactionDetails,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.REPORTED_TASKS_MANAGEMENT,
    component: ReportedTasksManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.REPORTED_TASK_DETAILS,
    component: ReportedTaskDetails,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
];
